<template>
  <v-layout class="d-flex flex-column h-screen">
    <v-main :class="containerState" class="d-flex flex-grow-1">
      <v-container id="main-container-definition" fluid>
        <v-card class="" flat>
          <v-card-text class="pa-0">
            <v-overlay
              v-model="overlay"
              class="align-center justify-center"
              contained
              opacity="1"
              scrim="white"
            >
              <v-progress-circular
                indeterminate
                size="64"
                color="secondary"
              ></v-progress-circular>
            </v-overlay>
          </v-card-text>
          <v-card-text
            class="pa-0 mx-auto d-flex justify-center"
            :opacity="opacityContent"
          >
            <v-sheet max-width="1280" width="100%">
              <v-row>
                <v-col cols="5">
                  <DescriptionCard
                    :containerHeight="containerHeight"
                    :parentDescription="sessionItem.description"
                    @updateDescription="updateDescription"
                  ></DescriptionCard>
                </v-col>
                <v-col cols="7">
                  <GeolocationCard
                    :containerHeight="containerHeight"
                    :parentGeolocation="sessionItem.definition.geolocation"
                    @updateGeolocation="updateGeolocation"
                  ></GeolocationCard>
                </v-col>
                <v-col cols="12">
                  <kpiMeasuresComponent
                    :containerHeight="containerHeight"
                    :apiUrl="apiUrl"
                    :realm="realm"
                    :parentDefinition="sessionItem.definition"
                    @updateSelectedItem="updateSelectedItem"
                    @toggleOverlay="toggleOverlay"
                  ></kpiMeasuresComponent>
                </v-col>
              </v-row>
            </v-sheet>
          </v-card-text>
          <v-card-actions class="pb-0" :class="!overlay ? 'd-flex' : 'd-none'">
            <v-btn
              variant="outlined"
              color="secondary"
              class="me-auto px-2"
              @click="routeToHome"
            >
              {{ $t("labels.cancel") }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              :disabled="!itemsSelected.length"
              variant="elevated"
              color="secondary"
              class="ml-2 text-white px-2"
              @click="routeToFormula"
            >
              <span v-if="sessionItem.id">{{ $t("labels.update") }}</span>
              <span v-else>{{ $t("labels.continue") }}</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-container>
    </v-main>
  </v-layout>
</template>

<script>
import events from "@/mixins/events.js";
import utils from "@/mixins/utils.js";
import mapMethods from "../mixins/mapMethods";
import DescriptionCard from "../components/DescriptionCard.vue";
import GeolocationCard from "../components/GeolocationCard.vue";
import kpiMeasuresComponent from "../components/kpiMeasuresComponent.vue";
export default {
  name: "demf-kpim-editor-definition",
  mixins: [events, utils, mapMethods],
  props: ["mfConfig", "realm"],
  components: {
    DescriptionCard,
    GeolocationCard,
    kpiMeasuresComponent,
  },
  data: function () {
    return {
      overlay: true,
      apiUrl: this.mfConfig.api,
      containerState: "expanded",
      loggedUserId: "",
      loading: false,
      itemsSelected: [],
      sessionItem: JSON.parse(sessionStorage.getItem("kpi")),
      containerHeight: "0px",
      opacityContent: 0,
    };
  },

  created() {
    this.overlay = true;
  },

  mounted() {
    this.loggedUserId = localStorage.getItem("loggedUserId");

    document.addEventListener("language-localstorage-changed", (event) => {
      this.setLocale(event.detail.storage);
    });

    this.containerState =
      localStorage.getItem("sidenav") === "opened" ? "reduced" : "expanded";

    document.addEventListener("sidenav-localstorage-changed", (event) => {
      this.containerState =
        event.detail.storage === "opened" ? "reduced" : "expanded";
    });

    this.$nextTick(() => {
      this.updateContainerHeight(); // Update dimensions
      window.addEventListener("resize", this.updateContainerHeight);
    });
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateContainerHeight);
  },

  methods: {
    setEditableStep(step, value) {
      document.dispatchEvent(
        new CustomEvent("editable-steps", {
          detail: { step, value },
        })
      );
    },

    toggleOverlay(value) {
      this.opacityContent = value ? 0 : 1;
      this.overlay = value;
    },

    //Calculate tag container height
    updateContainerHeight() {
      const element = document.getElementById("main-container-definition");
      if (element) {
        const elementCss = window.getComputedStyle(element);
        const paddingTop = parseFloat(
          elementCss.getPropertyValue("padding-top")
        );
        const paddingBottom = parseFloat(
          elementCss.getPropertyValue("padding-bottom")
        );
        this.containerHeight =
          element.offsetHeight - paddingTop - paddingBottom + "px";
      } else {
        console.warn("Not Found: ", element);
      }
    },
    //Redirect to Kpis list
    routeToHome() {
      this.$router.push({ path: "/kpis" });
    },
    //Updates sessionStorage, updates Editor step and continue to Formula page
    routeToFormula() {
      sessionStorage.setItem("kpi", JSON.stringify(this.sessionItem));
      this.setEditableStep("definition", 1);
      this.$router.push({ path: "/editor/formula" });
    },

    updateGeolocation(newGeolocation) {
      this.sessionItem.definition.geolocation = { ...newGeolocation };
    },
    updateDescription(newDescription) {
      this.sessionItem.description = newDescription;
    },
    updateSelectedItem(items) {
      this.itemsSelected = items;
      this.sessionItem.definition.selected = items;
    },
  },
};
</script>
<style scoped>
main.expanded {
  margin-left: 56px;
}
main.reduced {
  margin-left: 256px;
}
#main-container-definition {
  overflow-y: hidden;
}
main #main-container-definition {
  /*ControlPanel total height - toolbar - stepper - Footer*/
  height: calc(100vh - 64px - 104px - 40px);
}
</style>
